<template>
    <div class="modal-container-cont">
        <div class="overlay"></div>
        <div class="modal-container">
            <div class="modal-title">
                <h2>Como deseja prosseguir?</h2>
            </div>
            <div class="prod-cards">
                <!-- <div class="prod_item" @click="goToMenu()">
                    <div class="img_container">
                        <img :src="menuImage">
                    </div>
                    <div class="name_container">
                        <div class="container">
                            <span class="name">Ir para o cardápio</span>
                        </div>
                    </div>
                </div> -->
                <DefaultButton :text="getString('Ir para o cardápio')" :icon="menuImage" :outlined="false" @defaultBtnClick="goToMenu"></DefaultButton>
                <DefaultButton :text="getString('Ir para o checkout')" :icon="cartImage" :outlined="false" @defaultBtnClick="goToCheckout"></DefaultButton>
                <!-- <div class="prod_item"  @click="goToCheckout()">
                    <div class="img_container">
                        <img :src="cartImage">
                    </div>
                    <div class="name_container">
                        <div class="container">
                            <span class="name">Ir para o checkout</span>
                        </div>
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
import LocaleController from '@/assets/controllers/LocaleController'
import Util from '@/assets/libs/util'
import DefaultButton from '@/components/DefaultButton'
export default {
    name: 'GoMenuModal',
    components: {
        DefaultButton
    },
    data () {
        return {
            noImageSrc: null,
            junk: require('../../static/icons/junk-icon.png'),
            menuImage: require('../../static/icons/home.png'),
            cartImage: require('../../static/icons/btn-carrinho.svg')
        }
    },
    props: [
    ],
    mounted () {
    },
    methods: {
        getString: function (key) {
            return LocaleController.getString(key)
        },
        getImagesURL: function (prod, prop, size) {
            return Util.getImagesUrl(prod, prop, size)
            // return Util.getLocalConfigs('urlIMGOdhenInterface')
        },
        goToMenu: function () {
            this.$router.push({
                name: 'Home'
            })
        },
        goToCheckout: function () {
            this.$router.push({
                name: 'Checkout'
            })
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
@import (reference) url("../assets/common.less");

.modal-container-cont {
    .full;
    pointer-events: none;
    display: block;
    bottom: 0;
    z-index: 4;
}

.overlay {
    .full;
    background: black;
    opacity: .4;
}

.modal-container {
    pointer-events: auto;
    margin: auto 25px;
    padding: 0 5px 10px 0;
    background: @white;
    z-index: 4;
    box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.3);
    transform: translate(0%, -50%);
    display: flex;
    flex-direction: column;
    position: absolute;
    border-radius: 20px;
    top: 50%;
    left: 0;
    right: 0;

    .modal-title {
        background-color: @white;
        height: 100px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 25px 25px 0px 0px;

        h2 {
            font-size: 2.3rem;
            // color: @white;
            color: black
        }
    }

    .prod-cards {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-evenly;
        padding: 30px 0;

        .prod_item {
            width: 40%;
            height: auto;
            background-color: @white;
            text-align: center;
            margin: 20px;
            box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.1);
            border-radius: 5px;
            display: grid;
            grid-template-rows: 300px 100px;
            border: solid 1px rgb(160, 160, 160);
            padding: 20px 0;
            border-radius: 30px;
            .container {
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                width: calc(100% - 30px);
                padding: 0 15px;
            }

            .img_container {
                img {
                    object-fit: contain;
                    width: 100%;
                    max-height: 250px;
                    margin-top: 20px;
                    display: block;
                }
            }

            .name_container {
                position: relative;

                .name {
                    font-family: @default-font;
                    font-size: 1.2rem;
                    display: block;
                    max-width: 100%;
                    text-transform: uppercase;
                    text-align: center;
                    margin: auto;
                    padding: 0;
                }
            }

            .price_container {
                position: relative;

                .from {
                    text-transform: uppercase;
                    font-size: 1rem;
                    color: @primary-dark;
                    padding-top: 15px;
                }

                .price {
                    font-family: @default-font;
                    font-size: 1.2rem;
                    color: red;
                    margin: 0;
                }
            }
        }
    }
}

@media (min-width: 699px) and (max-width: 1025px) {

    //@tablet
    .modal-container {
        .modal-title {
            height: 100px;

            h2 {
                font-size: 30px;
            }
        }

        .prod-cards {
            .prod_item {
                width: 40%;
                height: auto;
                margin: 10px;
                grid-template-rows: 130px 80px;

                .container {
                    width: calc(100% - 30px);
                    padding: 0 15px;
                }

                &.slimMode {
                    box-shadow: unset;
                    grid-template-rows: 130px 70px;
                }

                .img_container {
                    img {
                        max-height: 110px;
                        margin-top: 10px;
                    }
                }

                .name_container {
                    .name {
                        font-size: 1.2rem;
                    }
                }
            }
        }
    }
}

@media (max-width: 698px) {

    // gertec
    .modal-container {
        margin: auto 35px !important;

        .modal-title {
            height: 70px;

            h2 {
                font-size: 20px;
            }
        }

        .prod-cards {
            max-height: calc(100vh - 350px);
            overflow: auto;

            .prod_item {
                width: 155px;
                height: fit-content;
                margin: 5px;
                grid-template-rows: 90px 70px 50px !important;

                .container {
                    width: calc(100% - 30px);
                    padding: 0 15px;
                }

                &.slimMode {
                    box-shadow: unset;
                    grid-template-rows: 130px 70px 50px;
                }

                .img_container {
                    img {
                        max-height: 90px !important;
                        margin-top: 10px;
                    }
                }

                .name_container {
                    .name {
                        font-size: 15px;
                    }
                }

                .price_container {
                    .container {
                        .from {
                            font-size: 14px;
                        }

                        .price {
                            font-size: 15px;
                        }
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/GoMenuModal.vue